export class TopNews {
  constructor() {
    this.$lists = document.querySelector('.js-toc-lists');
    this.$items = document.querySelectorAll('.js-toc-item');
    this.$tocActive = document.querySelector('.is-toc-active');
    this.$contentLists = document.querySelectorAll('.js-content-lists');
    this.$tocButton = document.querySelector('.js-toc-button');

    this.openState = false;

    this.orderClass = this._getOrderClass();
    this.eventType = this._getEventType();
    this._init();
    this._addEvent();
  }

  _getEventType() {
    const isTouchCapable =
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof DocumentTouch);

    return isTouchCapable ? 'touchstart' : 'click';
  }

  _removeOpen() {
    this.$lists.classList.remove('is-toc-open');
    this.$tocButton.classList.remove('is-toc-button-open');
    this.openState = false;
  }

  _toggle() {
    this.$lists.classList.toggle('is-toc-open');
    this.$tocButton.classList.toggle('is-toc-button-open');
    this._toggelOpenState();
  }

  _toggelOpenState() {
    this.openState = !this.openState;
  }

  _addTocActive(el) {
    this.$items.forEach((item) => {
      item.classList.remove('is-toc-active');
    });

    el.classList.add('is-toc-active');
    this.$tocActive = el;
  }

  _getOrderClass() {
    let orderClass = [];
    let nums = [];
    let i = 1;
    this.$items.forEach((item) => {
      nums.push(`${i}`);
      i++;
    });

    nums.forEach((num) => {
      orderClass.push(`is-order__${num}`);
    });
    return orderClass;
  }

  _removeOrderClass() {
    this.$items.forEach((el) => {
      this.orderClass.forEach((item) => {
        el.classList.remove(item);
      });
    });
  }

  _setOrder() {
    let orderNum = 1;
    for (let i = 1; i <= this.$items.length; i++) {
      if (this.$items[i - 1] == this.$tocActive) {
        this.$items[i - 1].classList.add('is-order__1');
      } else {
        orderNum++;
        this.$items[i - 1].classList.add(`is-order__${orderNum}`);
      }
    }
  }

  _getType(el) {
    let type = el.getAttribute('data-type');
    return type;
  }

  _getSameTypeContent(type) {
    let sameTypeContent;
    this.$contentLists.forEach((item) => {
      if (type == this._getType(item)) {
        sameTypeContent = item;
      }
    });
    return sameTypeContent;
  }

  _setContent() {
    this.$contentLists.forEach((item) => {
      item.classList.remove('is-content-open');
    });

    this.ContentType = this._getType(this.$tocActive);
    this.type = this._getType(this.$tocActive);
    this.$sameTypeContent = this._getSameTypeContent(this.type);
    this.$sameTypeContent.classList.add('is-content-open');
  }

  _addEvent() {
    this.$tocButton.addEventListener(this.eventType, () => {
      this._toggle();
    });

    this.$items.forEach((item) => {
      item.addEventListener(this.eventType, () => {
        this._addTocActive(item);
        this._removeOrderClass();
        this._setOrder();
        this._setContent();
        this._removeOpen();
      });
    });
  }

  _init() {
    this._setOrder();
    this._setContent();
  }
}
